export default __webpack_public_path__ + "static/media/image-frame-3.59c8bc4e.jpg";